import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { SingularEmailBaseCampaign } from '@feathr/blackbox';
import { EmailPreview, TLDR } from '@feathr/components';
import { useStore } from '@feathr/extender/state';

interface IProps {
  readonly campaign?: SingularEmailBaseCampaign;
}

function TemplateTLDR({ campaign }: IProps): JSX.Element | null {
  const { t } = useTranslation();
  const { Creatives, Templates } = useStore();
  const creatives = campaign?.isCreativesCampaign
    ? Creatives.list({ filters: { _parent: campaign.id }, pagination: { page_size: 1 } })
    : undefined;

  if (campaign === undefined || campaign.isPending || creatives?.isPending) {
    return <TLDR isLoading={true} />;
  }

  const previewUrl = campaign.getTemplatePreviewUrl();
  let subject: string | undefined;
  if (campaign.isPinpointEmail) {
    subject = campaign.get('subject');
  } else {
    const templateId = campaign.get('template_id');
    subject = templateId && Templates.get(templateId)?.get('subject');
  }
  const previewTitle = t('{{title}} Preview', { title: subject });

  return (
    <TLDR
      image={<EmailPreview title={previewTitle} url={previewUrl} />}
      isLoading={false}
      title={campaign.name}
    />
  );
}

export default observer(TemplateTLDR);
